import './ApiInfo.sass'
import {Row, Col, Jumbotron} from 'react-bootstrap'
import Markdown from 'comps/Markdown.js'
import {useState} from 'react'
import url from 'tool/url.js'


const ApiInfo = (props) => {
    const pathName = window.location.pathname.replace(/(\/)/g, '') // Remove initial slash.
    let fileName = props.info?.name
    fileName = fileName?.replace(/[()]/g, '')
    fileName = fileName?.replace(/[ ]/g, '_')
    fileName = fileName?.replace(/[^0-9a-zA-Z_]/g, '')
    
    //#region Download
    const [downloading, setDownloading] = useState(false)
    const [downloadError, setDownloadError] = useState(undefined)
    const download = () =>{
        setDownloading(true)
        setDownloadError(undefined)

        const settings = {
            method: 'GET',
            credentials: process.env.NODE_ENV === 'production' ? "same-origin" : "include"
        }

        fetch(url(`/doc/${pathName}`), settings)
        .then(res=>{
            if(res.status === 200){
                try {
                    return res.blob()
                } catch (error) {
                    setDownloading(false)
                    setDownloadError(new Error('Unable to create blob'))
                }
            }
            else {
                setDownloading(false)
                setDownloadError(res.status)
            }
        })
        .then(resBlob=>{
            let downloadLink = window.document.createElement('a')
            document.body.appendChild(downloadLink)
            downloadLink.href = window.URL.createObjectURL(resBlob, pathName)
            downloadLink.download = fileName
            downloadLink.click() 
            document.body.removeChild(downloadLink)
            setDownloading(false)
        })
        .catch(error=>{
            setDownloading(false)
            setDownloadError(error)
        })
    }
    //#endregion Download

    const btnStyle = {minWidth: 170}
    const btnDownload = (
        <button className="btn btn-primary" type="button" onClick={download} style={btnStyle}>
            <span>{downloadError? `${typeof downloadError === 'number' ? `(${downloadError})`: ''} Try again` : 'Download source'}</span>
        </button>
    )
    const btnDownloading = (
        <button className="btn btn-primary" type="button" disabled style={btnStyle}>
            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            <span>Downloading...</span>
        </button>
    )

    return<>
        <Row className="api_info-container d-flex align-items-center mt-5 no-gutters">
            <Col className="d-flex justify-content-start"><h1>{props.info?.name}</h1></Col>
            {downloading ? btnDownloading : btnDownload}
        </Row>
        <h2 className="mt-3">Description</h2>
        <Jumbotron className="api_info-description">
            <Col xs={12}>
                <Markdown>{props.info?.description}</Markdown>
            </Col>
        </Jumbotron>
    </>
}
  
export default ApiInfo